import { render } from "./ImportDividend.vue?vue&type=template&id=604d5f37&scoped=true&ts=true"
import script from "./ImportDividend.vue?vue&type=script&lang=ts"
export * from "./ImportDividend.vue?vue&type=script&lang=ts"

import "./ImportDividend.vue?vue&type=style&index=0&id=604d5f37&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604d5f37"]])

export default __exports__